export default "__VITE_ASSET__Cnnhy8HC__"